import React, {memo} from 'react';

import {getProperty} from '@optimaxdev/utils';
import classNames from 'classnames';

import {getFeatureAwareImage} from 'desktop/utils/lensTintsEg/lensTintsEg';
import {getCloudinaryURL} from 'libs/cloudinary/cloudinary';

import {CartItemEyeglassesType, CartItemType} from '../../types';
import {BaseItemImageZoom} from '../baseItemImageZoom/baseItemImageZoom';
import {BadgeType, CartItemBadges} from '../cartItemBadges/cartItemBadges';

import s from './baseItemImage.scss';

type PropsType = {
    item: CartItemType;
};

export const BaseItemImage = memo<PropsType>(
    ({item}) => {
        const imageUrl = `${getCloudinaryURL(getFeatureAwareImage(item, item.img, item.options))}`;
        return (
            <div
                className={classNames(s.wrapper, {
                    [s.accesoryImageRedesign]: item.type === 'accessories',
                })}
            >
                <BaseItemImageZoom alt={item.name} img={imageUrl} />
                <CartItemBadges badges={(item as CartItemEyeglassesType).badges as BadgeType[]} />
                <div
                    className={classNames(s.stockInfo, {
                        [s.accessoriesStockInfoRedesign]: item.type === 'accessories',
                    })}
                >
                    {item.stock?.isLowStock && (
                        <div className={classNames(s.stockStatus, s.low)}>
                            Only {item.stock.stockQty} left
                        </div>
                    )}
                    {item.stock?.isOutOfStock && (
                        <div className={classNames(s.stockStatus, s.out)}>Sold out</div>
                    )}
                </div>
            </div>
        );
    },
    (prevProps, nextProps) => {
        const {item: prevItem} = prevProps;
        const {item: nextItem} = nextProps;

        return (
            prevItem.img === nextItem.img &&
            prevItem.badge === nextItem.badge &&
            getProperty('stock.isLowStock')(prevItem) ===
                getProperty('stock.isLowStock')(nextItem) &&
            getProperty('stock.isOutOfStock')(prevItem) ===
                getProperty('stock.isOutOfStock')(nextItem)
        );
    },
);

BaseItemImage.displayName = 'BaseItemImage';
